import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-12 col-lg-8 col-xxl-7 offset-xxl-1 d-flex align-items-stretch mb-2" }
const _hoisted_5 = { class: "col-12 col-lg-4 col-xxl-3 d-flex align-items-stretch mb-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-xxl-10 offset-xxl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_carrer_summary_card = _resolveComponent("carrer-summary-card")!
  const _component_ranks_card = _resolveComponent("ranks-card")!
  const _component_team = _resolveComponent("team")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "col-12 text-center" }, [
            _createElementVNode("h3", null, [
              _createElementVNode("i", { class: "fas fa-cog me-1 fa-spin" }),
              _createTextVNode("Cargando...")
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ 'd-none': !_ctx.loaded })
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_carrer_summary_card, {
            leader: _ctx.leader,
            searching: _ctx.loadingTeam,
            onSearchUser: _ctx.searchUser,
            onReloadUser: _ctx.reloadUser
          }, null, 8, ["leader", "searching", "onSearchUser", "onReloadUser"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.loadingTeam && _ctx.UnilevelTeam?.leader.ranksCarrerData)
            ? (_openBlock(), _createBlock(_component_ranks_card, {
                key: 0,
                cardTitle: "Rangos",
                displayedRank: "next",
                "user-ranks-carrer-data": _ctx.UnilevelTeam.leader.ranksCarrerData,
                class: "flex-fill"
              }, null, 8, ["user-ranks-carrer-data"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_team, {
            team: _ctx.UnilevelTeam,
            loading: _ctx.loadingTeam
          }, null, 8, ["team", "loading"])
        ])
      ])
    ], 2)
  ]))
}